export default "__VITE_ASSET__DfHtq3XG__"